import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBD1 } from "../../../../../redux/app/crb/groups/crb-d";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBD1PreviewProps = OwnProps;
function CRBD1Preview(props: CRBD1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBD1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "D", 12, renderItem12()],
					[null, null, 13, renderItem13()],
					[null, null, 14, renderItem14()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem12() {
		if (crbRecord.item12.tanks.length > 0) {
			const totalQuantityDischarged = crbRecord.item12.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
								<th className="px-4 py-2 border text-center">Category</th>
								<th className="px-4 py-2 border text-center">Substance</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item12.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.catgeory}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.substance}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Quantity Discharged in Washing:{" "}
						{totalQuantityDischarged.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}

	function renderItem13() {
		return (
			<h4 className="font-medium uppercase">
				<ul>
					<li>
						No of cleaning machines per tank:{" "}
						{crbRecord.item13.noOfCleaningMachinesPerTank}{" "}
					</li>
					<li>
						Duration of wash/washing cycles (Hrs):{" "}
						{crbRecord.item13.durationOfWashingCycles}
					</li>
					<li>Wash Type: {crbRecord.item13.washType}</li>
				</ul>
			</h4>
		);
	}
	function renderItem14() {
		let { portName, receptionFacilityName, receiptAttachment, receiptNumber } =
			crbRecord.item14;
		return (
			<h4 className="font-medium uppercase">
				<ul>
					<li>Port: {portName}</li>
					<li>Reception Facility : {receptionFacilityName}</li>
					<li>Receipt: {receiptNumber}</li>
					<li>Attachment: {receiptAttachment}</li>
				</ul>
			</h4>
		);
	}

	return renderMain();
}

export default CRBD1Preview;
